﻿import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// #region Custom Classes

export class BaseOptionBoxDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Options?: BaseOptionBoxOption[];
}

export class BaseOptionBoxOption {
    DisplayText: string;
    Response: any;
    Color?: string;
    ClosesDialog?: boolean;

    constructor(displayText: string, color: string, response: any, closes ?: boolean) {
        this.DisplayText = displayText;
        this.Color = color || 'primary';
        this.Response = response;
        this.ClosesDialog = (closes != null ? closes : true);
    }
}

// #endregion

@Component({
    selector: 'dialog-optionbox-component',
    styleUrls: ['optionbox.dialogcomponent.css'],
    templateUrl: 'optionbox.dialogcomponent.html'
})
export class OptionBoxDialogComponent implements OnInit {
    title: string;
    message: string;
    options: BaseOptionBoxOption[];

    constructor(public dialogRef: MatDialogRef<OptionBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: BaseOptionBoxDialogOptions) {

        this.title = data.TitleText || 'Confirmation Requested...';
        this.message = data.MessageText || '';
        this.options = data.Options || [
            new BaseOptionBoxOption('OK', 'primary', true), new BaseOptionBoxOption('Cancel', 'warn', null)
        ];
    }

    OptionHandler(choice: BaseOptionBoxOption) {
        this.dialogRef.close(choice);
    }

    ngOnInit() {

    }
}

